export default __webpack_public_path__ + "static/media/pexels-pixabay-259006.3939f687.jpg";